<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeDemandeTempo.title')}}</h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{'button-access-no-permission' : !checkPermissions(permDemandeTempo.maj)}"
               @click="checkPermissions(permDemandeTempo.maj) ? save() : showPopUp()">
              {{ $t('general.button.sauvegarder')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :error="error"
                         :title="'editionClient.problemOccurred'"
                         :withEmplyFields="true"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         class="mgt-20px"
                         @close="error = $event"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="demandesSelect.length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-5">
            <b-input :placeholder="$t('listeDemandeTempo.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <div class="card" v-if="demandes.length === 0">
      <div class="card-content" >
        <div class="has-text-centered pdt-20px pdb-20px">
          <h1 class="title is-size-4">
            {{ $t('listeDemandeTempo.messages.errors.noResult')}}
          </h1>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card mgb-20px">
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-narrow">
              <b-checkbox :value="allDemandeSelected"
                          @input="selectAll()">
              </b-checkbox>
            </div>
            <div class="column is-narrow has-text-default is-size-7">
              {{ $t('listeDemandeTempo.messages.info.nbDemande', { nb: demandes.length }) }}
            </div>
          </div>
        </div>
      </div>
      <div v-for="(devis, index) in allDevis" :key="index" class="card mgb-20px">
        <info-devis :all-demandes="demandes"
                    :devis="devis"
                    :users="users"
                    @updateEtatObtenuReponse="updateEtatObtenuReponse"
                    @updateSelectDemande="updateSelectDemande">
        </info-devis>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import critereRechercheBaseDemandeTempo from '@/services/bodac/demandeTempo/critereRechercheBaseDemandeTempo';
import selecteurAction from '@/components/general/selecteurAction';
import { DEMANDE_TEMPO } from '@/configuration/permissionsBodacConf';
import ACTION_SIMULATION_ETAT from '@/configuration/bodac/demandeTempo/demandeTempoConf';
import { simulationEtatObtenu } from '@/api/devis';
import { SET_LIGNES_AVERTISSEMENT } from '@/store/modules/bodac/demandeTempo-mutation-type';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationLignesCommande from '@/services/dcf/validation/validationVentePartielle';
import { TYPE_DEVIS } from '@/configuration/devisConf';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsDevisTranslator';
import updateDevis from '@/services/bodac/demandeTempo/updateDevis';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageSucces from '@/services/general/messageSucces';
import { ATTENTE_REPONSE } from '@/configuration/optionBlocage/optionBlocage';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import infoDevis from '@/components/bodac/demandeTempo/infoDevis';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Demande = createNamespacedHelpers('demandeTempo');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      users: [],
      actions: [
        { action: ACTION_SIMULATION_ETAT, translation: 'listeDemandeTempo.actions.simulation' },
      ],
      permDemandeTempo: DEMANDE_TEMPO,
      unsubscribeValue: null,
    };
  },
  components: {
    breadcrumb,
    selecteurAction,
    errorMsgComponent,
    infoDevis,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Demande.mapGetters({
      demandes: 'items',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
      allDevis: 'devis',
    }),
    allDemandeSelected() {
      return this.demandes.length === this.demandesSelect.length && this.demandes.length > 0;
    },
    demandesSelect() {
      return this.demandes.filter((demande) => { return demande.selected; });
    },
    breadcrumb() {
      return [
        { title: this.$t('listeDemandeTempo.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeDemandeTempo.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    ...Demande.mapActions({
      loadDemande: 'loadDemandeTempo',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Demande.mapMutations({
      setLigneAvertissement: SET_LIGNES_AVERTISSEMENT,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    updateSelectDemande(ligneIds, select) {
      this.demandes.forEach((demande) => {
        if (!ligneIds.find((ligneId) => { return ligneId === demande.ligneId; })) return;
        demande.selected = select;
      });
    },
    updateEtatObtenuReponse(ligneId, etat) {
      const demande = this.demandes.find((demande) => {
        return demande.ligneId === ligneId;
      });
      if (!demande) return;
      demande.etatObtenuReponse = etat;
    },
    selectAll() {
      const selected = !this.allDemandeSelected;
      this.demandes.forEach((demande) => { demande.selected = selected; });
    },
    async recherche() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          query: cloneDeep(this.criteresRecherche),
          limit: NO_PAGINATION,
        };
        critereRechercheBaseDemandeTempo(data.query);
        data.query.societeId = this.societeActiveId;
        await this.loadDemande(data);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async simulerEtat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandesSelected = this.demandesSelect;
        const promiseSimulation = [];
        demandesSelected.forEach((demande) => {
          const params = {
            id: demande.ligneId,
            produitId: demande.produitId,
            anneeSemaine: demande.anneeSemaine,
            qteFacesSouhaitees: demande.qteFacesSouhaitees,
            etatSouhaite: demande.etatSouhaite,
            societeId: demande.societeId,
          };
          promiseSimulation.push(simulationEtatObtenu(params));
        });
        const rsltSimulation = (await Promise.all(promiseSimulation))
          .map((simulation => simulation.data.result));
        rsltSimulation.forEach((simulation) => {
          const demandeFind = this.demandes.find((demande) => {
            return demande.ligneId === simulation.id;
          });
          if (demandeFind) {
            demandeFind.etatObtenuReponse = simulation.etatObtenu;
            demandeFind.selected = false;
          }
        });
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.error = false;
        const lignesAUpdate = this.demandes.filter((demande) => {
          return demande.etatObtenuReponse !== ATTENTE_REPONSE;
        });
        const avertissements = await updateDevis(lignesAUpdate, this.allDevis);
        this.setLigneAvertissement(avertissements);
        if (lignesAUpdate.length - avertissements.length !== 0) {
          messageSucces(this.$t('listeDemandeTempo.messages.success.modifEtatObtenu'));
        }
        if (avertissements.length > 0) {
          this.messages.push({
            message: 'listeDemandeTempo.messages.errors.etatObtenuDiff',
          });
          this.error = true;
        }
        await this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data && e.response.data.error) {
          this.error = true;
          validationDevisCommande(e.response, this.messages, false, TYPE_DEVIS);
          const promises = this.allDevis.map((devis) => {
            return validationLignesCommande(e.response, this.messages, devis);
          });
          await Promise.all(promises);
          validationGeneral(
            this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate,
          );
        } else messageErreur(this.$i18n);
        await this.recherche();
        loadingComponent.close();
        throw e;
      }
    },
    handleAction(action) {
      switch (action) {
        case ACTION_SIMULATION_ETAT:
          if (!this.checkPermissions(this.permDemandeTempo.maj)) this.showPopUp();
          else this.simulerEtat();
          break;
        default:
          break;
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      this.users = this.parametre(PARAMETRES_KEYS.utilisateur);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, null);
      this.setInformationPage(this.$t('pageGescom.demande.liste'));
      await this.recherche();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
